import {
  ApiErrorCallback,
  ApiSuccessCallback,
  ApiSuccessCallbackParameterless,
} from './callback';
import { Employee } from '~/common/entities/Department/DepartmentTypes';
import { useAuthenticationService } from './AuthenticationService';
import { Todo } from '~/common/entities/Dayplan/DayplanTypes';
import { authenticatedApi } from '../utils/authenticatedApi';
import { createContainer } from 'unstated-next';
import { useState } from 'react';

function useDayplan() {
  const [todosOfEmployeeToShow, setTodosOfEmployeeToShow] =
    useState<Todo[]>(null);
  const [employeeIdToShow, setEmployeeIdToShow] = useState('');
  const { authenticationState } = useAuthenticationService();

  const getTodosOfEmployee = async (
    employee: Employee,
    onSuccess?: ApiSuccessCallback<Todo[]>,
    onError?: ApiErrorCallback,
  ) => {
    const { data, error } = await authenticatedApi(authenticationState).get<
      Todo[]
    >(`/todos/${employee.id}/`);
    if (error) {
      if (onError) onError(error);
      return;
    }
    if (data && onSuccess) onSuccess(data);
  };

  const deleteTodoFromEmployee = async (
    todo: Todo,
    employeeId: string,
    onSuccess?: ApiSuccessCallbackParameterless,
    onError?: ApiErrorCallback,
  ) => {
    const { error } = await authenticatedApi(authenticationState).delete<{}>(
      `/todos/${employeeId}/delete/${todo.id}`,
    );
    if (error && onError) onError();
    if (!error) {
      if (onSuccess) onSuccess();
      setTodosOfEmployeeToShow((todos) => todos.filter((t) => t.id != todo.id));
    }
  };

  return {
    todosOfEmployeeToShow,
    setTodosOfEmployeeToShow,
    employeeIdToShow,
    setEmployeeIdToShow,
    getTodosOfEmployee,
    deleteTodoFromEmployee,
  };
}

export const { Provider: DayplanProvider, useContainer: useDayplanService } =
  createContainer(useDayplan);
